// Copyright (c) Docugami, Inc. All rights reserved.

import { dgFontFamily } from "components/common/Fonts";
import { greyText, emptyGray } from "components/shell/presentation/AppStyles";
import { WorkPathType } from "networking/WorkPathApi";
import styled from 'styled-components';

const PageSectionTitleText = styled.span`
    font-family: ${dgFontFamily};
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: ${greyText};
`;

const SectionCommandsContainer = styled.div`
    display: flex;
    margin-left: auto;
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-top: 10px;
    align-items: center;
`;

const SectionDivider = styled.div`
    width: 100%;
    border-top: 2px solid ${emptyGray};
`;

const SectionFlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export interface SectionProps {
    types: WorkPathType[];
}

interface PageSectionProps {
    title: string;
    commands?: JSX.Element | JSX.Element[];
    children?: JSX.Element | JSX.Element[];
    className?: string;
    automationId: string;
}

export const PageSection = (props: PageSectionProps): JSX.Element => {
    return (
        <SectionFlexContainer className={props.className} data-automation-id={props.automationId}>
            <SectionDivider />
            <TitleContainer>
                <PageSectionTitleText>{props.title.toLocaleUpperCase()}</PageSectionTitleText>
                <SectionCommandsContainer>
                    {props.commands}
                </SectionCommandsContainer>
            </TitleContainer>
            {props.children}
        </SectionFlexContainer>
    );
}
